import { Button, Progress } from '@starsoft/common/components';

import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function WithdrawRolloverRequiredSkeleton() {
  return (
    <div className={styles.container}>
      <div className={`${styles.container__lottie} skeleton--secondary`} />
      <div className={styles.container__wrapper}>
        <div className={styles.container__wrapper__title}>
          <div className={skeleton.title} />
        </div>
        <div className={styles.container__wrapper__description}>
          <div className={skeleton.wrapper}>
            <div className={skeleton.description} />
            <div className={skeleton.description} />
            <div className={skeleton['description--half']} />
          </div>
        </div>
      </div>
      <div className={skeleton.factor__wrapper}>
        <div className={skeleton.factor} /> <div className={skeleton.factor} />
      </div>
      <Progress size="large" isLoading progress={0} />
      <Button isSkeleton />
    </div>
  );
}
